import React, { ReactElement } from 'react';
import { Typography, Box } from '@mui/material';
import { CabButton } from '@CabComponents/CabButton';
import { CabModal } from '@CabComponents/CabModal';
import colors from '../../colors';

export interface MergeContactsModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentContactName?: string | null;
  existingContactName?: string | null;
  email: string;
  isMerging?: boolean;
}

export const MergeContactsModal = ({
  open,
  onClose,
  onConfirm,
  currentContactName,
  existingContactName,
  email,
  isMerging = false,
}: MergeContactsModalProps): ReactElement => {
  const currentName = currentContactName || 'this contact';
  const existingName = existingContactName || 'another contact';

  return (
    <CabModal
      open={open}
      onClose={onClose}
      title="Email Already Exists"
      isAlert={true}
      noFullScreen={true}
      actionButtons={
        <>
          <CabButton buttonType="secondary" onClick={onClose} disabled={isMerging}>
            Cancel
          </CabButton>
          <CabButton onClick={onConfirm} disabled={isMerging}>
            {isMerging ? 'Merging...' : 'Merge Contacts'}
          </CabButton>
        </>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}>
        <Typography>
          The email address <strong>{email}</strong> already exists for {existingName}.
        </Typography>
        <Typography>
          Would you like to merge {existingName} with {currentName}? 
          This will combine all information from both contacts. Any fields that cannot be merged will be
          preserved on the primary contact ({currentName}).
        </Typography>
        <Typography variant="body2" color={colors.black800} sx={{ marginTop: 1 }}>
          This action cannot be undone.
        </Typography>
      </Box>
    </CabModal>
  );
};

export default MergeContactsModal;

